import moment from 'moment';
import DetailContainer from '../../../components/dataGrid/components/DetailContainer';
import ItemDetail from '../../../components/dataGrid/components/ItemDetail';

const DetalleRowPacientes = ({ row }) => {
    return (
        <DetailContainer>
            <ItemDetail>
                <strong>Mes:</strong> {row.mes || "-"}
            </ItemDetail>
            <ItemDetail>
                <strong>Año:</strong> {row.anio || "-"}
            </ItemDetail>
            <ItemDetail>
                <strong>Programa:</strong> {row.programa || "-"}
            </ItemDetail>
            <ItemDetail>
                <strong>F.Asignación:</strong> {row.fechaAsignacion}
            </ItemDetail>
            <ItemDetail>
                <strong>Frecuencia:</strong> {row.frecuencia ?? "-"}
            </ItemDetail>
            <ItemDetail>
                <strong># Evaluación:</strong> {row.idEvaluacion ?? "-"}
            </ItemDetail>
            <ItemDetail>
                <strong>Ultima visita:</strong> {row.fechaUltimaVisita ? `hace ${Math.round(moment().diff(moment(row.fechaUltimaVisita), 'days', true))} días` : "-"}
            </ItemDetail>
        </DetailContainer>
    );
};

export default DetalleRowPacientes;